import { actionClick } from '@lingoda/analytics';

export const actionGoToQuiz = () => actionClick('Go to Vocab Trainer');

export const actionResetQuiz = () => actionClick('Review Again Vocab Trainer');

export const actionReviewMore = () => actionClick('Keep Practising Vocab Trainer');
